import { inject, Injectable } from '@angular/core';
import { getStoresSnapshot, select } from '@ngneat/elf';
import {
  getAllEntities,
  getEntitiesCount,
  selectAllEntities,
  setEntities,
  upsertEntities,
} from '@ngneat/elf-entities';
import { Observable } from 'rxjs';

import { User } from '@digital-platform/rs-auth/domain';
import {
  NotificationEntity,
  NotificationItem,
  NotificationsRepository,
} from './notifications.repository';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private repo: NotificationsRepository = inject(NotificationsRepository);

  public state$: Observable<NotificationEntity[]> = this.repo.state$;
  public hasEntities = false;

  constructor() {
    this.state$.subscribe((notificationEntities) => {
      this.hasEntities = this.repo.store.query(getEntitiesCount()) > 0;

      // eslint-disable-next-line no-restricted-syntax
      console.debug(`notificationEntities changed:`, notificationEntities);
    });
  }

  public set(serviceAlerts: NotificationItem[]): void {
    const entities = this.repo.createEntities(serviceAlerts);

    this.repo.set(entities);
  }

  public upsert(serviceAlerts: NotificationItem[]): void {
    const entities = this.repo.createEntities(serviceAlerts);

    this.repo.upsert(entities);
  }

  public reset(): void {
    this.repo.reset();
  }

  public getStateSnapshot(): NotificationEntity[] {
    return this.repo.store.query(getAllEntities());
  }
}
